import React from 'react';
import { VStack, Divider } from 'native-base';
import MenuHeader from './MenuHeader';
import MenuChannelsHeader from './MenuChannelsHeader';
import Channels from './Channels';
import MenuLinks from './MenuLinks';
const MenuSide = props => {
  return /*#__PURE__*/React.createElement(VStack, {
    display: props.display,
    alignItems: 'center',
    style: {
      marginLeft: '20px'
    }
  }, /*#__PURE__*/React.createElement(MenuHeader, {
    navigation: props.navigation,
    startNewTopicButtonRef: props.startNewTopicButtonRef
  }), /*#__PURE__*/React.createElement(MenuChannelsHeader, null), /*#__PURE__*/React.createElement(Channels, {
    orientation: 'vertical',
    setPage: props.setPage,
    setHasMoreTopics: props.setHasMoreTopics
  }), /*#__PURE__*/React.createElement(Divider, {
    mt: 5,
    mb: 5
  }), /*#__PURE__*/React.createElement(MenuLinks, {
    isGuidelineModalOpen: props.isGuidelineModalOpen,
    setIsGuidelineModalOpen: props.setIsGuidelineModalOpen
  }));
};
export default MenuSide;
//# sourceMappingURL=MenuSide.js.map